import { Badge, HStack, Text, Tooltip, VStack } from '@chakra-ui/react';
import React from 'react';
import { FaHospital } from 'react-icons/fa';

interface Practice {
  id?: string | null;
  name: string;
}

interface MultiClinicBadgeProps {
  practices: Practice[];
}

const MultiClinicBadge: React.FC<MultiClinicBadgeProps> = ({ practices }) => {
  if (practices.length <= 1) return null;

  return (
    <Tooltip
      label={
        <VStack align="start" spacing="0.25rem" p="0.25rem">
          <Text fontSize="0.7rem" fontWeight="700" color="white">
            {practices.length} clinics:
          </Text>
          {practices.map((p, i) => (
            <Text
              key={`${p.id ?? 'no-id'}-${p.name}-${i}`}
              fontSize="0.7rem"
              color="gray.200"
            >
              {p.name}
            </Text>
          ))}
        </VStack>
      }
      hasArrow
      placement="top"
      openDelay={150}
    >
      <Badge
        display="inline-flex"
        alignItems="center"
        gap="0.25rem"
        px="0.45rem"
        py="0.2rem"
        borderRadius="full"
        bg="blue.50"
        border="1px solid"
        borderColor="blue.200"
        color="blue.700"
        fontSize="0.65rem"
        fontWeight="700"
        cursor="default"
        flexShrink={0}
        letterSpacing="0.01em"
        aria-label={`Linked to ${practices.length} clinics`}
      >
        <HStack spacing="0.2rem" align="center">
          <FaHospital size={10} />
          <span>{practices.length} Clinics</span>
        </HStack>
      </Badge>
    </Tooltip>
  );
};

export default MultiClinicBadge;
